// assets
import { IconEqual, IconEqualNot, IconBusinessplan } from '@tabler/icons';
import ScaleIcon from '@mui/icons-material/Scale';
import ListIcon from '@mui/icons-material/List';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import StorefrontIcon from '@mui/icons-material/Storefront';

// constant
const icons = {
    IconEqual,
    IconBusinessplan,
    IconEqualNot,
    ScaleIcon,
    ListIcon,
    CompareArrowsIcon,
    StorefrontIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const opciones = {
    id: 'opciones',
    title: 'Opciones',
    type: 'group',
    children: [
        {
            id: 'Homologados',
            title: 'Homologados',
            type: 'item',
            url: '/homologados',
            target: false,
            icon: icons.StorefrontIcon
        },
        {
            id: 'NoHomologados',
            title: 'No Homologados',
            type: 'item',
            url: '/nohomologados',
            target: false,
            icon: icons.ScaleIcon
        }
    ]
};


export default opciones;
